import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideIfInvalid'
})
export class HideIfInvalidPipe implements PipeTransform {
  transform(data: null | string | string[]): boolean {
    return !(data == null || data === '' || data === 'N/A' || data.length == 0);
  }
}
